import el from 'element-ui/lib/locale/lang/zh-TW';

/* eslint-disable */
export default {
  app: {
    hi: ' bonjour',
    name: 'Okubuy',
    login: 'Login',
    logout: 'déconnexion',
    register: "s'inscrire",
    reset_password: 'Reset mot de passe',
    default: 'default',
    create_account: 'Créer un compte',
    delete: 'supprimer',
    edit: 'éditer',
    tips: 'prompt',
    confirm: 'OK',
    cancel: 'Annuler',
    save: 'save',
    view_more: 'Voir plus',
    view: 'Voir la commande',
    share: 'Partager',
    submit: 'submit',
    no_limit: 'Illimité',
    file_only_accept_jpg_png: 'Le fichier téléchargé ne peut être que du format jpg, png',
    file_size_only: "La taille de l'image téléchargée ne peut pas dépasser {taille}",
    search: 'recherche',
    reset: 'reset',
    select_all: 'tout sélectionner',
    inputMoreThanWords: "L'entrée ne peut pas contenir moins de {0} caractères",
    please_login: 'Veuillez vous connecter au premier compte',
    submit_err: 'Submit failed',
    delete_err: 'delete failed',
    search_bar_placeholder: "Entrez l'élément ou le nom de la marque, recherchez l'élément entier",
    loading_captcha: 'Chargement du code de vérification ...',
    loading: 'Chargement...',
    currency: 'La monnaie',
    yes: 'Yes',
    none: 'No',
        },
  topbar: {
    faq: 'Foire Aux Questions',
    guide: 'Guide du débutant',
    exchange_rate: 'taux de change de référence',
  },
  nav: {
    home: 'Maison',
    shop: 'boutique',
    forwarding: 'transfert',
    more_classify: 'Afficher plus de catégories >>',
    proxy_request: "Demande d'achat",
    product_promotion: 'Référence produit',
    straight: 'achat direct',
    proxy_buy: 'Achat',
    new_product: 'Derniers produits',
    off_price_product: 'Offre spéciale',
    hot_sales_product: 'éléments chauds',
    recommend_product: 'Article recommandé',
    free_postage_product: 'marchandises emballées',
    all_product: 'tous les biens',
  },
  faq: {
    most_popular_questions: 'La question la plus chaude',
    account_registration: 'Enregistrement du membre',
making_purchase: 'Acheter des biens',
package: 'Colis et envoi',
other_questions: 'Other',
answer_your_questions: 'Cette FAQ répond-elle à votre question? ',
thankyou_for_your_feedback: 'Soumettre avec succès! Merci beaucoup pour vos commentaires, nous continuerons à travailler dur pour être meilleurs! ',
ask_us: "Je n'ai pas encore trouvé de réponse? Demandez nous. ",
we_respond_within_2days: 'Nous répondons généralement dans les 2 jours ouvrables. Les questions les plus populaires apparaîtront sur cette page. ',
subject: 'thème',
your_name: 'nom',
cellphone_portable: "numéro de téléphone",
email: 'boîte aux lettres',
category: 'Classification',
question: 'problème',
    placeholder: {
name: 'indiquez votre nom',
email: 'Entrez votre adresse email',
category: 'Veuillez sélectionner le type de question',
question: "S'il vous plaît remplir votre question",
subject: "S'il vous plaît remplir votre sujet",
cellphone: "S'il vous plaît, entrez votre numéro de téléphone",
    },
    rules: {
      name: 'Le nom ne peut pas être vide',
email: "L'adresse email ne peut pas être vide",
correct_email: "Veuillez saisir l'adresse e-mail correcte",
category: 'Veuillez sélectionner le type de question',
question: 'La question ne peut pas être vide',
question_len: 'La question comporte au moins 3 caractères',
subject: 'Le sujet ne peut pas être vide',
    },
  },
  shop_names: {
    rakuten: 'Rakuten',
    yahoo_jp: 'YAHOO!JAPAN',
    amazon_jp: 'Amazon JP',
  },
  login: {
    page_title: 'Se connecter ou créer un compte',
    registered: 'Enregistré?',
    login_tips: 'Si vous avez déjà un compte, connectez-vous',
    mobile_authenticated: 'Le numéro de mobile est enregistré?',
    mobile_tips: "S'il vous plaît entrez votre numéro de téléphone portable pour obtenir le code de vérification du code de vérification SMS",
    remember_me: 'Souviens-toi de moi',
    forgot_password: 'Mot de passe oublié',
    placeholder: {
      account: 'Veuillez saisir votre compte ou votre adresse e-mail',
      password: 'Entrez votre mot de passe de connexion',
      mobile: 'Entrez le numéro de téléphone enregistré',
    },
    rules_message: {
         account_required: 'Veuillez entrer votre identifiant de connexion ou votre email',
      password_required: 'Veuillez saisir votre mot de passe de connexion',
      mobile_required: 'Veuillez entrer votre numéro de téléphone portable',
      mobile_error: "S'il vous plaît entrez le numéro de téléphone mobile correct",
      captcha_required: 'Veuillez saisir le code de vérification SMS',
    },
      accountLogin: 'Connexion au compte',
    smsLogin: 'Connexion au code de vérification SMS',
    thridPartyLogin: 'Login tiers',
    get_sms_captcha: 'Obtenir le code de vérification',
    sms_captcha: 'Code de vérification SMS',
    resend: 'resend',
    register: 'Membre enregistré',
    un_regisered: 'Pas encore enregistré?',
    register_tips: 'Inscrivez-vous gratuitement et rapidement!',
    registered_infos: [
      'Peut rapidement payer',
      'Peut se connecter à plusieurs adresses de livraison',
      "Être capable de voir l'état de la commande de suivi",
    ],
    login_fail: 'Connexion échouée',
  },
  reset: {
    send: 'envoyer',
    reset: 'Reset mot de passe',
    email: 'boîte aux lettres',
    password: 'mot de passe',
    confirm_password: 'confirmer le mot de passe',
  },
  register: {
    page_title: 'Créer un compte',
    register_tips: 'Entrez les informations suivantes pour créer votre compte',
    accepted: 'Accepter et continuer',
    reject: 'rejeter',
    read_and_accepted: "J'ai lu et accepté",
    labels: {
      email: 'email',
phone: 'numéro de téléphone',
      password: 'mot de passe',
      password_confirmation: 'Confirmer le mot de passe',
      referral_code: "Numéro de membre d'introduction",
    },
    placeholder: {
      email: "S'il vous plaît entrez votre adresse email",
      phone: "S'il vous plaît entrez votre numéro de téléphone",
      password: 'Définissez votre mot de passe, la longueur doit être comprise entre 6 et 20 caractères',
      password_confirmation: 'Veuillez confirmer votre mot de passe à nouveau',
      referral_code: 'Entrez le numéro de membre de votre parrain, facultatif',
    },
    rules_message: {
      email_type: "S'il vous plaît entrez le bon email",
      email_required: "Merci de renseigner l'adresse email",
      phone_required: 'Merci de renseigner votre numéro de téléphone',
      password_required: 'Veuillez saisir votre mot de passe de connexion',
      password_length: 'La longueur doit être comprise entre {min} et {max} caractères',
      password_confirmation_required: 'Veuillez confirmer le mot de passe à nouveau',
      password_not_comfirmed: 'Le mot de passe entré deux fois est incohérent',
    },
  },
  activation: {
    thank_you_registered: 'Merci pour votre inscription {appname}',
    active_your_account: "S'il vous plaît activer votre compte",
    send_mail_tips: 'Nous avons envoyé un email à votre adresse email: {email}, veuillez suivre les instructions pour envoyer votre compte par email',
    resend_link: "Si vous n'avez pas reçu l'e-mail, cliquez ici pour le renvoyer",
    activing: 'Activer votre compte ...',
    activation_successed: 'Votre compte a été activé, je vous souhaite un bon shopping! !',
    bind_successed: 'Liaison réussie, je vous souhaite un bon shopping! !',
    activation_failed: "l'activation a échoué",
  },
  user: {
    user_center: 'Member Center',
    my_account: "Mon compte",
    my_orders: 'Ma commande',
    product_view_history: 'Mes empreintes de pas',
    lately_history: 'Empreintes récentes',
    add_recommend: "Plus remise d'achat",
    lately_orders: 'Commandes récentes',
    not_lately_orders: 'Pas de nouvelles commandes récemment',
    not_lately_history: 'Pas de nouvelles empreintes récemment',
    not_lately_wishlist: "Pas d'articles favoris",
    not_lately_ship: 'Aucune adresse de livraison ajoutée',
    history_err: "Échec de l'obtention de mon empreinte",
    informations: 'Informations personnelles',
    wish_list: 'Ma collection',
    shipping_address: 'adresse de livraison',
    proxy_list: "demande d'achat",
registration_in: "S'inscrire à",
    last_login_time: 'Dernière heure de connexion',
    coupon: 'mon coupon',
    integral: 'Mes points',
    coupons: 'Coupon',
    promotion: 'Promouvoir',
        generalize: 'niveau de promotion',
    member: 'niveau membre',
    balance: '«mon solde»',
    logout: 'déconnexion',
    order_detail: 'Détails de la commande',
    orders_err: "Echec de l'obtention de la commande",
    go_to_login: 'Aller à la connexion',
    added_to_wishlist: 'Added to Favorites',
    removed_wishlist: "n'a plus de favoris",
    success: 'Modifier avec succès',
    screen: 'Filtre de classification',
    upload_img_err: "La taille de l'image téléchargée de l'avatar ne doit pas dépasser 2 Mo!",
    type: 'Type',
    content: 'Le contenu',
    time_limit: 'Terme',
    immediate_use: 'Utiliser maintenant',
    be_usable: 'Disponibles',
    used: 'Utilisé',
    expired: 'A expiré',
    no_coupons: 'Aucun coupon disponible'
  },
  guide: {
    registered_members: 'Membre enregistré',
    buy: 'Comment acheter',
    payment: 'conditions de paiement',
    charge: 'Achat de marchandise',
    pay_attention: 'commentaires et termes',
    first: {
      one: '1: enregistrement',
two: "S'il vous plaît cliquez sur le lien 'Inscription' dans le coin supérieur droit de la page d'accueil pour accéder à la page d'inscription des membres. Cliquez sur Enregistrer. ",
three: "2: Définir l'identifiant, le mot de passe et l'adresse e-mail de l'utilisateur",
four: "«L'ID utilisateur peut être défini comme adresse électronique ou numéro de téléphone et entrer une adresse électronique valide pour recevoir des courriels de confirmation. ",
five: "«Après avoir défini l’ID utilisateur, le mot de passe et l’adresse électronique, cliquez sur le bouton' Soumettre 'pour soumettre la demande d’adhésion. ",
      six: '3: Mail de confirmation',
seven: "After completing the registration, please go to your registered email address to open the email sent to you by OKUBUY and confirm the link to confirm the account. \n" +
        "Lorsque l'adresse e-mail est confirmée, l'enregistrement du compte membre est terminé et vous pouvez utiliser ce compte pour acheter. Si vous n'avez pas reçu l'e-mail, vérifiez votre courrier indésirable. ",
    },
    second: {
      one: 'achat direct OKUBUY',
      two: "Les articles publiés dans la zone d’achat direct OKUBUY sont tous des produits au comptant, qui peuvent être envoyés rapidement après l’achat. Une fois le paiement effectué, si les marchandises se trouvent déjà dans l’entrepôt, elles seront expédiées le lendemain. ",
three: "Si vous souhaitez fusionner et envoyer d'autres articles d'achat, vous pouvez cliquer sur' Envoyer à mon entrepôt 'lorsque vous choisissez le mode d'expédition. Lorsque l'article acheté sera livré, il sera expédié avec la fonction d'emballage combiné. ",
four: "Étant donné que les marchandises entrent directement dans le processus d'achat une fois le paiement effectué, sauf en cas de rupture de stock ou de fluctuation du prix, la commande ne peut être annulée. Veuillez confirmer la commande avant l'achat. ",
five: 'Après avoir recherché l’article que vous souhaitez acheter, cliquez sur le bouton "Ajouter au panier". ',
six: 'Confirmez le contenu du produit et le montant total. Si les informations sont correctes, cliquez sur le bouton "Paiement". ',
seven: "Après avoir confirmé l'adresse de facturation, cliquez sur le bouton' Continuer '. ",
eight: 'Après avoir sélectionné le mode de livraison, cliquez sur le bouton Continuer. ',
nine: 'Après avoir sélectionné le mode de paiement et confirmé le contenu de la commande, cliquez sur le bouton "Commander" pour valider votre commande. ',
ten: "Après avoir terminé la commande, vous pouvez vérifier le contenu de la commande à tout moment sur la page de commande dans 'Mon compte'. OKUBUY vous enverra un courrier électronique pour vous avertir après l'achat de votre commande. ",
      eleven: "achat Amazon ou Ratuten",
      twelve: "Tant que vous cliquez sur la page d'achat de 'OK Amazon' ou 'Ratuten Lotte' sur la page d'accueil d'OKUBUY, vos paniers Amazon / Ratuten iront directement dans le panier OKUBUY. ",
      thirteen: "Autres achats de sites Web",
fourteen: "OKUBUY peut acheter des articles qui ne peuvent être achetés que sur le site officiel de la marque ou dans d'autres magasins. Veuillez remplir le formulaire 'Achat' et payer une fois la commande confirmée. ",
fifteen: "Étant donné que les marchandises entrent directement dans le processus d'achat une fois le paiement effectué, sauf en cas de rupture de stock ou de fluctuation du prix, la commande ne peut être annulée. Veuillez confirmer la commande avant l'achat. ",
    },
    third: {
      one: 'mode de paiement',
      two: '«Acceptez les paiements par Paypal, Payme, WeChat, Alipay et votre compte bancaire.',
    },
    fifth: {
      one: 'A propos de la marchandise',
      two: "1. Le côté du colis (long, large ou haut) ne peut excéder 60 cm de part et d'autre. S'il dépasse 60 cm, il doit être chargé en fonction du poids volumétrique.",
      three: '2. La longueur totale du colis (longueur et hauteur des trois côtés) ne doit pas dépasser 120 cm. Si elle dépasse 120 cm, elle doit être chargée en fonction du poids volumétrique.',
      four: 'mode de livraison',
      five: '«Lorsque les marchandises arriveront à Hong Kong, elles seront notifiées par E-MAIL afin qu’elles viennent les chercher (gratuitement) ou les livrent à domicile (avec supplément).',
    },
    fourth: {
      Calcul: "calcul des frais d'achat des produits",
            country: ['', 'Japon', 'États-Unis', 'Australie', 'Anglais', 'Français', 'Coréen', 'Thaïlande', 'Taiwan'],
      fee: ["taxe", "30", "30", "30", "30", "30", "30", "30", '30'],
internation: ["'Expédition internationale (par kilogramme)'", '40', '40', '40', '40', '40', '40', '40', '40'],
      local: ['fret local', "Selon les frais d'achat du site Web / de la boutique, les frais réels sont facturés. "],
            price: ['prix des produits de base', 'prix des produits de base et taux de change actuels'],
      localPrice: ['expédition locale', '8%', '8%', '8%', '8%', '8%', '8%', '8%', '8%'],
    }
  },
  user_info: {
    personal: 'Modifier les données',
    avatar_image: 'Télécharger avatar',
    login_name: "nom d'utilisateur",
    update_password: 'Changer le mot de passe',
    old_password: "mot de passe d'origine",
    new_password: 'nouveau mot de passe',
    confirm_password: 'confirmer le mot de passe',
    keep: 'Sauvegarder',
    actual_name: 'nom réel',
    can_only_be_changed_once: "Le nom de connexion ne peut être modifié qu'une seule fois",
    gender: 'genre',
    male: 'mâle',
    female: 'femme',
    secrecy: 'inconnu',
    birthday: 'Anniversaire',
    Choose_birthday: 'Choisir la date',
    phone_number: 'numéro de téléphone',
    change_password: 'Le mot de passe a été modifié avec succès',
  },
  order: {
    id: 'numéro de commande',
    type: 'type de commande',
    quantité: 'quantité',
    amount: 'montant',
    status: 'Statut de la commande',
    order_date: 'date de commande',
    subtotal: 'sous-total',
    name: 'nom du produit',
    price: 'prix',
    size: 'taille',
    color: 'couleur',
    shipping: 'fret',
    tax: 'taxe',
    sale_tax: 'taxe à la consommation',
    import_tax: "taxe d'importation",
    total: 'total',
    total_tax: 'taxe',
    payment: 'payez maintenant',
    shipping_fee: 'fret',
    local_shipping_fee: 'expédition locale',
    overseas_shipping_fee: "Expédition à l'étranger",
    handling_fee: 'taxe de traitement',
    contains_shipping_fee: 'avec expédition',
    order_detail: 'Détails de la commande',
    created_at: 'temps de commande',
    cancel_order: 'annuler la commande',
    filter_all: 'Toutes les commandes',
    filter_unpaid: 'En attente de paiement',
    filter_delivered: 'Envoi en attente',
    filter_shipping: 'Marchandises en attente',
    filter_uncomment: 'à évaluer',
    filter_closed: 'Fermé',
    filter_completed: 'Completed',
    filter_wait_for_pickup: 'En plus de mentionner',
    filter_last_3_months: 'Commande des 3 derniers mois',
    filter_last_6_months: 'Dernier ordre semestriel',
    Filter_input_placeholder: 'Recherche du numéro de commande ou du nom du produit',
    payment_method: 'Méthode de paiement',
    payment_status: 'status du paiement',
    payment_timeout_tips: "S'il vous plaît payer avant le délai d'attente, la commande de délai d'attente est automatiquement fermée",
    wait_for_ship: "En attente d'expédition entrepôt",
    step1: 'Soumettre une commande',
    step2: "Paiement réussi",
    step3: 'Livraison des produits',
    step4: 'Confirmer le reçu',
    step5: 'evaluation',
    step6: 'Paiement en attente',
        shipping_info: 'Recevoir des informations',
    shipping_method: 'méthode de livraison',
    payment_info: 'Information de paiement',
    products: 'Commander des marchandises',
    total_product: "prix total de l'article",
        total_price: 'prix total',
    order_closed: "L'ordre de temporisation sera automatiquement fermé: ",
    successful_payment: "Le paiement a réussi, dans l'attente de l'expédition du vendeur",
    shipped: 'Le marchand a expédié, veuillez faire attention au reçu',
    comment: "L'acheteur a reçu les marchandises, vous pouvez évaluer les marchandises",
    suborder_splited_payment_tips: 'Cette commande appartient à la sous-commande de {main_order}, veuillez vous rendre sur la page de commande principale pour effectuer le paiement. Veuillez nous pardonner pour tout inconvénient.',
    view_main_order: 'Voir la commande principale',
    tracking_parcel: 'Suivi du colis',
    commodity: 'marchandises',
    detail: 'détails',
    comment_btn: 'Évaluation',
    operating: 'Opération',
    del_order: 'Annuler la commande',
    buy_again: 'Acheter à nouveau',
    product_add_car: 'S\'il faut commander à nouveau le produit dans le panier',
    change_payment_method: 'Changer de mode de paiement',
    view_logistics: 'Voir la logistique',
    to_pay: 'Payer'
  },
  wish_list: {
    product_name: 'nom du produit',
    wish_poduct: 'Collecter des biens',
    wish_add_car: 'Ajouter au panier',
    clear_wish_list: 'Effacer la liste des favoris',
    add_to_wish_list_err: "Échec de l'ajout de favoris",
        remote_wish_list_err: 'La suppression des favoris a échoué',
    confirm_clear_list: 'Êtes-vous sûr de vouloir effacer la liste?'
  },
  product: {
    none_specification: "Aucune donnée de spécification et d'emballage",
    none_comment: 'Pas de commentaire',
    none_advisories: 'Aucune consultation',
        distribution: 'rappel de livraison',
    id: "ID d'article",
    product: 'marchandises',
    name: 'nom du produit',
    product_categories: 'Classification du produit',
    detail: 'détaillé',
    price: 'prix',
    old_price: "prix d'origine",
    unit_price: 'prix unitaire',
    specification: 'Spéc',
    brand: 'marque',
    unit_tax: 'taxe',
    original_price: "prix d'origine",
    total: 'payer le prix total',
    quantity: 'quantité',
    subtotal: 'sous-total',
    product_details: 'Détails du produit',
    upc: "numéro d'article",
    inventory: 'inventaire',
    availability: 'disponibilité',
    description: 'Détails du produit',
    comment: 'Commentaire',
    comment_has_number: 'Comment ({0})',
    product_name: 'nom du produit',
    weight: 'poids',
    length: 'longueur',
    width: 'largeur',
    height: 'hauteur',
    specification_and_packaging: 'Image du produit',
    advisories: 'consulting',
    advisories_has_number: 'Consultation ({0})',
    comment_time: 'Commentaire time',
    recovery_time: 'Reply time',
    let_us_help_you_to_answer_your_doubts: 'Proposez vos doutes, laissez-nous vous aider à répondre',
    to_ask_questions: 'Question',
    question: 'Q',
    answer: 'Réponse',
    no_answer: 'Pas encore de réponse',
    advisory_err: 'La question a échoué',
    input_more_than4_words: 'Veuillez entrer plus de 4 mots',
    product_list: 'Liste de produits',
    all_categories: 'toutes les catégories',
    load_more: "Charger plus d'éléments",
    load_more_error: "Échec du chargement de l'élément, veuillez réessayer plus tard",
    tax_included: 'taxes incluses',
    stock_inform: "avis d'arrivée",
    more: 'Plus >>',
    distribution_nonsupport: 'Pays ou région ne prenant pas en charge la distribution',
    serve: 'service',
    serve_content: 'Cet article est fabriqué par',
    shipments: 'expédition',
    source: 'source',
    delivery: 'Livraison',
    pickup: 'Frais d’autofinancement',
    pickups: '{price} yens pour les commandes complètes',
    freight: 'Fret',
    freights: 'Frais de transport gratuits pour les commandes complètes {price}',
    estimated_time: 'Devrait arriver dans {time} jours',
    authentic_guarantee: 'Garantie authentique',
    returns: 'Support pour le retour',
    in_stock: 'En stock',
    not_returns: 'Ne supporte pas le retour',
    not_returns_txt: 'Cet article ne prend pas en charge le retour et l\'échange',
    authentic_guarantee_txt: 'OKUBUY promet que les produits vendus sont 100% authentiques',
    returns_txt: '7 jours après la vente, le problème de qualité / manquant peut être appliqué après la vente et le produit peut être renvoyé après l\'approbation.',
    in_stock_txt: 'Les marchandises sont en stock, livraison normale sous 48h',
    product_upc: 'CUP de marchandises',
    coupon: 'Coupon',
    restricted_purchase: 'Achat restreint',
    hkTo: 'Entrepôt de Hong Kong à ',
                                                                },
  product_list: {
    shop_categories: 'Classification du produit',
    price_range: 'gamme de prix',
    filter: 'filtre',
    filter_by_brand: 'Filtrer par marque',
    filter_by_source: 'Filtrer par source',
    list_page_total: 'Total {0} articles',
    sort_by: 'sort',
    sort_by_index: 'complet',
    price: 'prix',
    sort_by_new: 'durée de conservation',
    search_keyword: 'mot-clé de recherche',
    brand: 'marque',
    loading_goods: "Chargement de plus d'éléments",
    loading_goods_not: 'Plus de marchandises',
  },
  shipping_address: {
    add_address: 'Ajouter une nouvelle adresse',
    consignee: "destinataire",
    mobile: 'téléphone portable',
    phone: 'mots fixes',
    email: 'Email',
    district: 'région',
    zip_code: 'code postal',
    address: 'adresse',
    line1: 'Adresse détaillée 1',
    line2: 'adresse détaillée 2',
    company: 'société',
    additional_information: 'extra information',
    set_default: 'default',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette adresse de livraison? ',
    deleted: "L'adresse de livraison a été supprimée",
    label: 'adresse étiquette',
    label_placeholder: 'Recommandé pour un nom commun',
    reference_name: 'nom de référence',
    my_home: 'famille',
    apartment: 'Appartement',
    parents_home: 'Parents',
    express_box: 'Express Cabinet',
    school: 'école',
    warehouse: 'Entrepôt',
    hostel: 'Hôtel',
    consignee_placeholder: 'indiquez le nom du destinataire',
    zip_code_placeholder: 'Remplissez le code postal',
    email_placeholder: "Recevoir un courrier d'information sur la logistique de la commande",
    company_placeholder: 'indiquez le nom de la société',
    mobile_placeholder: 'indiquez le numéro de téléphone mobile',
    area_code: 'indicatif régional',
    phone_placeholder: '(numéro de téléphone fixe)',
    select_district: "Veuillez sélectionner la zone d'adresse de livraison",
    address_placeholder: "Il est recommandé de saisir l'adresse de livraison détaillée, telle que le nom de la rue, le numéro de rue, le numéro de l'étage et de la pièce, etc.",
    additional_information_placeholder: '',
    confirm_close_dialog: "L'adresse de livraison n'a pas encore été enregistrée, est-il déterminé à être fermé? ",
    edit_address: "modifier l'adresse",
    required_field_no_compltet: 'Avec * est requis, veuillez remplir le champ',
    address_has_been_save: 'Adresse enregistrée',
    tracking_number: 'numéro de suivi',
    zipcode: 'code postal',
    rules: {
      label_reduired: "S'il vous plaît remplir l'étiquette d'adresse pour votre commodité",
      consignee_reduired: 'Merci de renseigner le nom du destinataire',
      zipcode_required: 'Merci de renseigner le code postal',
      email_reduired: "Veuillez renseigner l'adresse e-mail",
      email: "S'il vous plaît remplir la bonne adresse email",
      mobile_reduired: 'Veuillez entrer votre numéro de téléphone',
      selectedDistricts_reduired: "Veuillez sélectionner la zone de l'adresse de livraison",
      line1_required: 'Entrez votre adresse de livraison',
    },
  },
  area: {
    US: 'America',
    France: 'France',
    UK: 'Angleterre',
    Germany: 'Allemagne',
    Malaysia: 'Malaisie',
    Australia: 'Australie',
    NewZealand: 'Nouvelle-Zélande',
    Singapore: 'Singapore',
    Thailand: 'Thaïlande',
    Japan: 'Le japon',
    Korea: 'Corée',
    VietNam: 'Vietnam',
    Cambodia: 'Cambodge',
    China: 'Chine continentale',
    HongKong: "Hong Kong",
    Macau: 'Macao',
    TaiWan: "Taiwan",
  },
  footer: {
    contacts: 'Consulting',
    contact_us: 'Contactez-nous',
    phone: 'téléphone',
    monday_friday: 'lundi au vendredi',
    customer_service: 'Service client',
    faq: 'Foire Aux Questions',
    delivery: 'Arrangement de distribution',
    payment_method: 'méthode de paiement',
    information: 'Information',
    news: 'Dernières nouvelles',
    terms_and_conditions: 'Termes et conditions',
    privacy_policy: 'Politique de confidentialité',
    about_us: 'Contactez-nous',
    my_account: "Mon compte",
    contact_us_me: 'Contactez-nous',
    subscription: 'subscribe',
    show_map: "Afficher l'adresse de la carte",
subscribe: 'Abonnez-vous à notre newsletter pour recevoir des réductions, des nouvelles, des informations commerciales et promotionnelles. ',
     },
  article: {
release_time: 'release time',
warehousing_and_delivery: 'Colis in and out',
ask_us: "Je n'ai pas encore trouvé de réponse? Demandez nous ",
we_normally_respond: 'Nous répondons généralement dans les 2 jours ouvrables. Les questions les plus courantes apparaîtront sur cette page. ',
your_name: 'votre nom',
category: 'Classification',
question: 'problème',
placeholder: {
name: 'indiquez votre nom',
category: 'Veuillez sélectionner le type de question',
question: 'Écrivez votre question',
},
  },
  home: {
    featured_products: 'Items sélectionnés',
    sale_products: 'Offre spéciale',
    top_sellers: 'Hot marchandise',
    new_arrivals: 'Derniers produits',
    recommend_products: 'Articles recommandés',
    popular_brands: 'Marque populaire',
    shipping: 'Livraison gratuite',
    shipping_detailed: 'Livraison gratuite pour les commandes de plus de 100 $',
    money_back: "garantie de remboursement",
    money_back_detailed: 'Nous le retournerons dans les 30 jours',
    customer_support: 'support client 24/7',
    customer_support_detailed: 'Support client amical 24 heures sur 24, 7 jours sur 7',
    secure_online_payment: 'Paiement en ligne sécurisé',
    secure_online_payment_detailed: 'Nous avons un certificat de sécurité / SSL',
  },
  cart: {
    add_to_cart: 'Ajouter au panier',
    cart: "panier d'achat",
    view_cart: "Voir le panier d'achat",
    price: 'prix unitaire',
    checkout: 'Settlement',
    no_login_tips: "Les articles du panier seront enregistrés sur votre compte après la connexion",
    continue_shipping: 'Continuer à magasiner',
    operation: 'opération',
    remove: 'supprimer',
    add_to_wishlist: 'Collecter des marchandises',
    added_to_wishlist: 'a été collecté',
    delete_wislist: 'Annuler la collecte',
    defeated_delete_wislist: 'Annuler la collecte a échoué',
    product_has_been_removed: "L'article a été retiré du panier",
    product_has_benn_removed_to_wishlist: "L'article a été déplacé dans les favoris",
    product_move_to_wishlist_and_remove_cart: "L'article est déplacé vers les favoris et le panier est supprimé",
    update_to_cart_err: 'La mise à jour du panier a échoué',
    empty_cart_tips: "Votre panier ne contient aucune marchandise",
    total_product: "prix total de l'article",
    total_tax: "total de l'impôt",
    add_to_cart_err: "Échec de l'ajout au panier",
    update_cart_err: "La modification du panier d'achat a échoué",
    it_is_cheaper: "Le prix est moins cher qu'avant",
    it_is_expensive: "Le prix est plus cher qu'avant",
    remove_err: 'Supprimer échoué',
    add_to_cart_success: 'Ajouté avec succès au panier',
  },
  redemption_center: {
  name: 'à partir du point de référence',
    district: 'région',
    address: 'adresse',
    phone: 'téléphone',
    business_hours: "heures d'ouverture",
  },
  order_pay: {
    pay_id: 'PAY ID',
    amount: 'montant',
    pay_time: 'Délai de paiement',
  },
  checkout: {
    product: 'marchandises',
    unit_price: 'prix unitaire',
    unit_tax: 'taxe',
    sale_tax: 'taxe à la consommation',
    import_tax: "taxe d'importation",
    merchandise_news: 'Informations sur le produit',
    remarks: 'Entrez les informations du commentaire',
    quantité: 'quantité',
    price: 'prix',
    additional_information: 'extra information',
    billing_information: 'Informations de facturation',
        shipping_methods: 'méthode de livraison',
    self_pick_up: 'Du point de vue du ramassage',
    district_only_hk: 'Prend temporairement uniquement en charge la livraison à Hong Kong',
    courier: 'Express',
    self_point_address: 'adresse du point de soulèvement automatique',
    shipping_address: 'adresse de livraison',
    add_shipping_address: 'Ajouter une adresse de livraison',
    payment_method: 'Méthode de paiement',
    audit_order: 'order order',
    order_created: 'La commande a été créée',
    prev: 'Étape précédente',
    next: 'Suivant',
    back_to_cart: 'Retour au panier',
    your_cart_is_empty: 'Votre panier ne contient aucune marchandise',
    area_group_diffent_tips: 'Selon votre adresse de livraison, le système réglera automatiquement la devise dans le lieu de réception.',
        go_to_shopping: 'Faire du shopping',
    submit_orders: 'Soumettre une commande',
    picker: 'de la personne',
    phone: 'numéro de portable',
    consignee_form_validate_error: 'Merci de renseigner les informations correctes sur le destinataire',
    logistics_type: 'Type de logistique',
    logistics_fee: 'Coût',
    logistics_estimated_time: 'Temps estimé',
    logistics_type_1: 'Service express',
    logistics_type_2: 'Spécial express',
    logistics_type_3: 'Service standard',
    free_postage_tips: 'Invite：Livraison gratuite pour les commandes de plus de {price}',
    free_pick_up_tips: 'Invite: Frais de livraison gratuits pour les commandes de plus de {price}',
        placeholders: {
      name: 'Le nom du préparateur utilisé pour vérifier lors de la prise en charge',
      phone: 'Le mot de passe de collecte sera envoyé au numéro de téléphone portable, assurez-vous que le numéro peut être envoyé par SMS',
    },
    rules: {
      picker_required: 'Merci de renseigner le nom du destinataire',
      phone_required: 'Veuillez saisir le numéro de téléphone du destinataire, le mot de passe de collecte sera envoyé au numéro de téléphone portable',
    },

    checkout_fail: 'Echec de la vérification',
    get_self_point_address_err: "Échec de l'obtention du point de levée",
    get_shipping_address_err: "Impossible d'obtenir l'adresse de livraison",
    please_select_checkout_item: "Veuillez sélectionner l'élément à extraire",
    order_split_tips: 'Les produits de votre commande se trouvent dans des entrepôts différents et doivent être fractionnés et livrés séparément. Veuillez nous pardonner pour tout inconvénient. ',
    please_input_promote_code: "Veuillez saisir votre code d'offre",
    promote_code_placeholder: "Entrez le code de l'offre",
    promo_code: 'Code promo',
    Remote_areas: 'Supplément d\'adresse résidentielle ou distante de HKD $ 20, qui sera facturé par le chauffeur. Si le refus de payer le supplément d\'adresse résidentielle ou distante entraîne un échec de livraison, le client devra payer des frais de livraison supplémentaires.',
    none: 'Non utilisé',
    day: 'jours',
                                },
  shipping_fee: {
    free_pick_up_price: 'Frais d\'auto-retrait gratuits de plus de {price}',
    pick_up_price: 'Insatisfaction à l\'égard des frais supplémentaires d\'auto-retrait {price}',
    free_postage_condition: 'Livraison gratuite à partir de {price}',
    desc_1: 'Insatisfait des frais d\'expédition {price}',
    desc_2: 'Premier poids{first_weight}{weight_unit} {first_weight_price}，Poids continu{add_weight}{weight_unit} {add_weight_price}',
    additional_fees: 'Coût supplémentaire',
    import_tax: 'Droit d\'importation',
    sale_tax: 'Taxe de consommation',
  },
    proxy_request: {
    code: 'numéro',
    contact_phone: 'Contact Phone',
    product_name: 'nom du produit',
    product_url: 'item URL',
    image: 'image',
    price: 'prix de référence',
    quantité: 'quantité',
    size: 'modèle / taille',
    color: 'couleur',
    remark: 'Remarques',
    created_at: 'date',
    statut: 'statut',
    click_upload: 'Cliquez sur Upload',
    placeholders: {
    contact_phone: "S'il vous plaît laissez votre numéro de contact, afin que le service client puisse confirmer votre achat",
    product_name: 'Entrez le nom du produit que vous devez acheter',
    product_url: "Entrez l'URL de l'article que vous devez acheter",
    price: 'Le prix de référence de la marchandise en HKD, le prix de transaction réel est soumis à la commande',
    size: 'Si la page du produit contient plusieurs modèles / tailles, veuillez saisir le modèle / la taille dont vous avez besoin',
    color: "Si la page du produit contient plusieurs couleurs, entrez la couleur dont vous avez besoin",
    },
    rules: {
      contact_phone_required: 'Merci de laisser votre numéro de téléphone afin que le client puisse confirmer votre achat',
      product_name_required: 'Merci de renseigner le nom du produit',
      product_url_required: "Veuillez renseigner l'URL du site de shopping",
      product_url: "Veuillez saisir l'adresse URL correcte en commençant par http: // ou https: //",
      price_required: "Merci de renseigner le prix du produit",
      quantity_required: 'Merci de renseigner la quantité de biens achetés',
      shipping_method_required: 'Veuillez sélectionner le mode de livraison',
      redemption_center_id_required: 'Veuillez sélectionner votre propre point',
      address_id_required: "Veuillez sélectionner l'adresse de livraison",
      payment_method_required: "S'il vous plaît payer d'abord avec paypal",
    },
    please_add_shipping_address: "S'il vous plaît ajouter l'adresse de livraison en premier",
    not_found: "Il n'y a pas de demande d'achat",
    updated: "Votre demande d'achat a été modifiée",
    created: "a soumis votre demande d'achat",
    canceled: "Votre demande d'achat a été annulée",
    reject: "Votre demande d'achat a été rejetée",
    reject_reason: 'rejeter la raison',
    cancel: 'Annuler',
    cancel_tips: "Êtes-vous sûr de vouloir annuler cette demande d'achat? ",
  },
  rakuten: {
    product_detail: 'marchandise Rakuten',
    product_info: 'Informations sur le produit',
    tax_include: 'taxes comprises',
    view_item_from_rakuten: 'Reading Lotte Page',
    shop_name: 'nom de magasin',
    item_code: "code de l'article",
    category: 'Classification',
    tag: 'tag',
    review_count: "numéro d'évaluation",
    review_count_text: '{0} critiques sur les produits',
    review_average: 'Évaluation complète',
    shipping_tips: "Si les marchandises sont interdites ou interdites à la vente à l'étranger, elles risquent de ne pas pouvoir passer la douane. Nous annulerons les commandes pour de tels articles. S'il te plaît, pardonne-moi. ",
  },
  yahoo: {
    product_detail: 'marchandise Yahoo',
    view_item_from_yahoo: 'Lire la page Yahoo',
    shop_name: 'nom de magasin',
    item_code: 'code de magasin',
    review_count: "numéro d'évaluation",
    review_count_text: '{0} critiques sur les produits',
    review_average: 'Évaluation complète',
    category: 'Classification',
    product_info: 'Informations sur le produit',
    view_review: 'Voir le classement',
    shipping_tips: "Si les marchandises sont interdites ou interdites à la vente à l'étranger, elles risquent de ne pas pouvoir passer la douane. Nous annulerons les commandes pour de tels articles. S'il te plaît, pardonne-moi. ",
  },
  amazon: {
    product_detail: 'marchandise Amazon',
  },
  information: {
    information: 'Information',
    news: 'Dernières nouvelles',
    terms_and_conditions: 'Termes et conditions',
    privacy_policy: 'Politique de confidentialité',
    about_us: 'Contactez-nous',
  },
  facebook_pannel: {
    homepage: "page d'accueil facebook",
    line1: 'Bonjour notre compte facebook',
    line2: "Vous pouvez en apprendre davantage sur les dernières nouvelles d'Okuboy ici",
  },
  transport: {
    parcel_list: 'liste de paquets',
    warehouses: "Adresse de l'entrepôt",
    parcel_information: "Entrez l'adresse de l'entrepôt, l'entreprise de messagerie, le numéro de suivi et les informations relatives à l'envoi pour confirmer l'envoi",
    parcel_screen: 'Filtrage des paquets de stimulation',
    goods_name: 'nom de la marchandise',
    valuation_fee: 'Coût assuré (HKD)',
    parcel_describe: 'Post description du colis',
    parcel_status: 'Post status colis',
    track_num: 'Numéro de suivi',
    ware: 'Entrepôt',
    weight_pounds: 'poids (livres)',
    courier_tracknum: 'Société express / numéro de suivi',
    new_status: 'last state',
    product_details: 'Détails du produit / valeur',
    push_parcel: 'paquet de messagerie push actif',
    cancel_record: "Annuler l'enregistrement",
    completion_information: 'Complete information',
    addgoods: 'Ajouter un article',
    send_out: 'send',
    placeholder: {
      choose: "S'il vous plaît sélectionner",
      warehouse_courier: "Choisissez l'adresse de l'entrepôt et l'entreprise de messagerie",
      status: "S'il vous plaît sélectionner le statut",
      warehouses: "S'il vous plaît choisir entrepôt",
      tracking_num: 'Entrez le numéro de suivi',
    },
   label: {
      warehouse_courier: "Adresse de l'entrepôt et entreprise de messagerie",
      tracking_num: 'numéro de suivi',
      unit: 'unité'
   },
  },
  pickup_point_selector: {
    pickups: 'De points de mention',
    post_office: 'post office',
    address: 'adresse',
  },
  validate: {
    mobile: "S'il vous plaît entrez le numéro de téléphone correct",
    fixline: "S'il vous plaît entrez le numéro de téléphone correct",
  },
  remove: {
     a: 'Membre principal',
     b: "promoteurs primaires",
   },
   payment: {
     paypal: 'PayPal',
     alipay: 'Alipay',
     wechatpay: 'paiement WeChat',
     go_to_alipay_website_for_payment: 'Allez au paiement du site Web Alipay',
     use_alipay_app_scan: "Utiliser Alipay APP' pour glisser 'Paiement'",
     use_fps_scan: 'Paiement par code QR',
     use_wechat_app_scan: "Utiliser WeChat' pour analyser 'Paiement",
     pay_with_alipay: 'paiement Alipay',
     payment_error: 'Le paiement a rencontré une erreur, veuillez contacter le service clientèle. ',
     has_the_payment_been_completed: 'Paiement terminé? ',
     pay: 'Paiement',
     checkout_counter: 'Caisse enregistreuse',
     sub_order1: 'Veuillez effectuer le paiement dans les ',
     sub_order2: 'après avoir soumis la commande, sinon la commande sera automatiquement annulée',


     order_timeout: 'Le délai de paiement de la commande a expiré',
     order_not_pay: "Cette commande n'est actuellement pas payable",
     order_paid_successful: 'Commande payée avec succès',
     go_to_alipay_app_for_payment: "Accédez à l'application alipay pour le paiement",
     no_orders: 'Aucune commande',
   },
  comment: {
    order_evaluation: 'Évaluation de la commande',
    order_number: 'Numéro de commande',
    product_rating: 'Note du produit',
    product_review: 'Évaluation du produit',
    commodity_order: 'Ordre de marchandise',
  },
  state: {
    choose_your_country_or_region: 'Choisissez votre pays ou région',
    africa_middle_east_and_india: 'Afrique, Moyen-Orient et Inde',
    asia_pacific: 'Asie Pacifique',
    europe: 'Europe',
    latin_america_and_the_caribbean: 'Amérique latine et les Caraïbes',
    the_united_states_canada_and_puerto_rico: 'États-Unis, Canada et Porto Rico',
  },
            tracking_statuses: {
     1: 'Nouvelle commande',
     2: 'est arrivé au point de départ',
     3: 'Envoyer un SMS pour informer les clients à récupérer',
     4: "L'invité a ramassé",
     10: "Prévisions",
     11: "acquisition",
     12: 'En transit',
     13: 'Dans la pièce',
     14: 'Signé',
     15: 'Paiement échoué',
     16: 'Autre',
     17: 'Recevez',
     18: 'à la pièce',
     19: 'Guest signature',
     20: 'question pièce',
   },
  ...el,
}
